import Icon from '@design-systems/react-icons'
import VettingStepConfig from './VettingStepConfig'
import {
  CODE_RFI_TYPE_SUPPLIER,
  CODE_RFI_TYPE_LOCATION,
  CODE_RFI_TYPE_QUESTIONNAIRE,
  PARAM_MANUFACTURING_TYPE_ID,
} from '../../common/commonConstants'
import { Link } from 'react-router-dom'

const VettingsStep = (props) => {
  const getRouteUrl = () => {
    switch (props.auditStepDetails?.rfi_type?.toLowerCase()) {
      case CODE_RFI_TYPE_SUPPLIER:
        return `/internal/rfi1?supplierId=${props.supplierId}&${PARAM_MANUFACTURING_TYPE_ID}=${props.manufacturingTypeId}`
      case CODE_RFI_TYPE_LOCATION:
        return `/internal/rfi2?locationId=${props.locationId}&supplierId=${props.supplierId}&${PARAM_MANUFACTURING_TYPE_ID}=${props.manufacturingTypeId}`
      case CODE_RFI_TYPE_QUESTIONNAIRE:
        return `/internal/rfi3?locationId=${props.locationId}&supplierId=${props.supplierId}&${PARAM_MANUFACTURING_TYPE_ID}=${props.manufacturingTypeId}`
      default:
        return ''
    }
  }

  const status = props.auditStepDetails?.vetting_status?.toLowerCase()
  const stepConfig = VettingStepConfig[status]
  const owner = props.auditStepDetails?.vetting_status_updated_by || '-'

  return (
    <Link to={getRouteUrl()} className="vetting-step-link">
      <div
        className="vetting-step-style cursor-pointer"
        key={`card-audit-trail-${props.index}`}
      >
        <div className="vetting-step-content">
          <span className="vetting-step-rfi-type">
            {props.auditStepDetails?.rfi_type || '-'}
          </span>

          {stepConfig?.icon && (
            <Icon
              svg={stepConfig.icon}
              aria-hidden
              className={`vetting-step-status-icon ${stepConfig?.class || ''}`}
            />
          )}

          <span className={`vetting-step-status ${stepConfig?.class || ''}`}>
            {props.auditStepDetails?.vetting_status || '-'}
          </span>

          <span className="vetting-owner-name-style" title={owner}>
            {owner}
          </span>

          <span className="vetting-step-date">
            {props.auditStepDetails?.vetting_status_updated_date || '-'}
          </span>
        </div>
      </div>
    </Link>
  )
}

export default VettingsStep
